import { useQuery } from '@tanstack/react-query';
import { ITruckerProfileProps } from 'interfaces/profile.interface';

import { getTruckerByPhoneOrDocument } from 'services/searchTrucker';

export const SEARCH_TRUCKER_KEY = 'search-trucker';

export const useOpenSearchQuery = (valueParameter?: string, isEnabled?: boolean) =>
  useQuery<ITruckerProfileProps, Error>({
    queryKey: [SEARCH_TRUCKER_KEY],
    queryFn: async () => {
      const res = await getTruckerByPhoneOrDocument(valueParameter);
      if (!res?.trucker) {
        throw new Error('No trucker data available');
      }
      return res;
    },
    enabled: isEnabled,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    gcTime: 0,
  });
